import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {GroupeLIBPRListPage} from './GroupeLIBPRListPage'
import {GroupeLIBPRPage} from './GroupeLIBPRPage'

const GroupeLIBPRWrapper = () => {
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Paramètres',
                    path: '#',
                    isSeparator: false,
                    isActive: true,
                  },
                ]}
              >
                Groupe LIBPR
              </PageTitle>
              <GroupeLIBPRListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Groupe LIBPR', path: '/groupe-libpr', isSeparator: false, isActive: true},
                ]}
              >
                Création
              </PageTitle>
              <GroupeLIBPRPage />
            </>
          }
        />
        <Route
          path='/:groupeLibprId/modifier'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Groupe LIBPR', path: '/groupe-libpr', isSeparator: false, isActive: true},
                ]}
              >
                Modification
              </PageTitle>
              <GroupeLIBPRPage />
            </>
          }
        />
        <Route index element={<Navigate to='/groupe-libpr/liste' />} />
      </Routes>
    </>
  )
}

export {GroupeLIBPRWrapper}
